import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerBaseInformation = {
  async customerBaseInformation(parent, args, context, info) {
    const { customerNumber } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CUSTOMERS,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    const customer = await getCustomer({ number: customerNumber })

    // means that the information that is required is not available
    if (!customer || !customer?.custom?.fields) return null

    let billingAddress

    // if either defaultBillingAddressId we use it to find billing address
    if (customer.defaultBillingAddressId) {
      billingAddress = customer.addresses.find((address) => address?.id === customer.defaultBillingAddressId)
    } else if (customer?.billingAddressIds?.length > 0) {
      // in case defaultBillingAddressId is not available, we use billingAddressIds first array value
      billingAddress = customer.addresses.find((address) => address?.id === customer.billingAddressIds[0])
    }

    const customFields = customer.custom.fields

    const billingInformation = {
      companyName: customer.companyName || null,
      postalCode: billingAddress?.postalCode || null,
      streetName: billingAddress?.streetName || null,
      additionalStreetInfo: billingAddress?.additionalStreetInfo || null,
      city: billingAddress?.city || null,
      pOBox: billingAddress?.pOBox || null,
    }

    // TODO: https://reply.atlassian.net/browse/EINZA-486?focusedCommentId=47601
    const contactData = {
      phoneNumber: billingAddress?.phone,
      mobileNumber: billingAddress?.mobile,
      fax: billingAddress?.fax,
      email: billingAddress?.email,
    }

    const taxComplianceData = {
      vatId: customer.vatId || null,
      intrastatDeclaration: customFields?.intrastatDeclaration || null,
      // TODO: https://reply.atlassian.net/browse/EINZA-486?focusedCommentId=47601
      dic: null,
      ico: null,
    }

    const otherData = {
      associationNumber: customFields?.associationNumber || null,
      tourNumber: customFields?.tourNumber || null,
      truckTourNumber: customFields?.truckTourNumber || null,
      invoiceEmail: customFields?.invoiceEmail || null,
      customerClassification: customFields?.customerClassification || null,
      vatKey: customFields?.vatKey || null,
      collectiveInvoiceKey: customFields?.collectiveInvoiceKey || null,
      paymentMethod: customFields?.paymentMethod || null,
      dunningKey: customFields?.dunningKey || null,
      dunningBlock: customFields?.dunningBlock || false,
      orderConfirmation: customFields?.orderConfirmation || null,
      branchName: customFields?.industryKey?.obj?.value
        ? JSON.parse(customFields?.industryKey?.obj?.value)?.branchText || null
        : null,
      admSalesRepresentive: customFields?.admSalesRepresentive || null,
      expertAdvisor: customFields?.expertAdvisor?.split("-")[1] || null,
      insideServiceEmployee: customFields?.insideServiceEmployee?.split("-")[1] || null,
      einzaCreditLimit: customFields?.einzaCreditLimit || null,
      hermesCreditInsurance: customFields?.hermesCreditInsurance || false,
      hermesCreditLimit: customFields?.hermesCreditLimit || null,
      hermesLimitMaximum: customFields?.hermesLimitMaximum || false,
      offerAvailable: customFields?.offerAvailable || false,
      notify: customFields?.notify || false,
      recordOrderNumberOnDeliveryNote: customFields?.recordOrderNumberOnDeliveryNote || false,
      printSellingPrice: customFields?.printSellingPrice || false,
      controlInvoices: customFields?.controlInvoices || false,
      processingFee: customFields?.processingFee || false,
      freightSurcharge: customFields?.freightSurcharge || false,
      underInvoicing: customFields?.underInvoicing || false,
      webShopCustomer: customFields?.webShopCustomer || false,
      installmentPayment: customFields?.installmentPayment || false,
      lawyerHired: customFields?.lawyerHired || false,
      legalSettlement: customFields?.legalSettlement || false,
      bankcruptcy: customFields?.bankcruptcy || false,
      orderConfirmationEmail: customFields?.orderConfirmationEmail || null,
      skontoText: customFields?.discountKey?.obj?.value
        ? JSON.parse(customFields?.discountKey?.obj?.value)?.skontoText || null
        : null,
      // TODO: https://reply.atlassian.net/browse/EINZA-486?focusedCommentId=47601
      dataExchangeSystem: null,
      status: customFields?.customerStatus || null,
      costUnitMandatory: customFields?.cost_unit_mandatory || false,
    }

    return {
      id: customer.id,
      billingInformation,
      contactData,
      taxComplianceData,
      otherData,
    }
  },
}
